<template>
  <div class="yht-backStage-hsdt">
    红色动态
  </div>
</template>

<script>

export default {
  name: 'hsdt',
  data () {
    return {

    }
  },
  props: {
  },
  created () {

  },
  methods: {
  }
}
</script>

<style scoped>

</style>
